import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { request } from './axios';

class ApiClient {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  public get(
    endpoint: string,
    queryParams?: Record<string, string | number | boolean | undefined>,
    options?: AxiosRequestConfig,
  ) {
    return this.apiInstance.get(endpoint, { params: queryParams, ...options });
  }

  public post(endpoint: string, body?: Record<string, unknown>, options?: AxiosRequestConfig) {
    return this.apiInstance.post(endpoint, body, options);
  }

  public put(endpoint: string, body: Record<string, unknown>, options?: AxiosRequestConfig) {
    return this.apiInstance.put(endpoint, body, options);
  }
  public delete(endpoint: string, options?: AxiosRequestConfig) {
    return this.apiInstance.delete(endpoint, options);
  }

  public patch(endpoint: string, body: Record<string, unknown>, options?: AxiosRequestConfig) {
    return this.apiInstance.patch(endpoint, body, options);
  }
}

export const apiClient = new ApiClient(request);
